class YotpoClient {
  constructor(props) {
    this.endpoint = `https://api.yotpo.com/`;
    this.app_key = props.app_key;

    if (!this.app_key) {
      throw new Error("Yotpo app key is required");
    }

    this.clientOptions = {
      headers: { "Content-Type": "application/json" },
    };
  }

  getStoreReviews = async (ids = []) => {
    return new Promise((resolve, reject) => fetch(
      `${this.endpoint}v1/widget/${this.app_key}/reviews.json`, this.clientOptions
    ).then(response => {
      response.json().then(resp => {
        resolve(resp.response.reviews)
      }).catch(reject);
    }).catch(reject));
  }

  getProductReviews = async (productId) => {
    return new Promise((resolve, reject) => fetch(
      `${this.endpoint}v1/widget/${this.app_key}/products/${productId}/reviews.json`, this.clientOptions
    ).then(response => {
      response.json().then(resp => {
        resolve({...resp.response.bottomline, product_id: productId})
      }).catch(reject);
    }).catch(reject));
  }
}

if (typeof window !== "undefined" && typeof window.convertflow == "undefined") {
  window.YotpoClient = YotpoClient;
}
